/**
 * @generated SignedSource<<9aecc7d33576b2eb8a1f65b4e86826bb>>
 * @relayHash 04e20c65d82b994b907b9b06ffc42221
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04e20c65d82b994b907b9b06ffc42221

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type SimulateAutomaticallyAssignDoctorInput = {
  country: Country;
  date: any;
  isMedicalSupervisor: boolean;
  language: Language;
  slotId: number;
  specialty: ServiceSpecialty;
};
export type sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery$variables = {
  input: SimulateAutomaticallyAssignDoctorInput;
};
export type sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery$data = {
  readonly simulateAutomaticallyAssignDoctor: {
    readonly assignedDoctor: string | null;
    readonly debugBagAsJson: string;
  };
};
export type sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery = {
  response: sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery$data;
  variables: sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SimulateAutomaticallyAssignDoctorOutput",
    "kind": "LinkedField",
    "name": "simulateAutomaticallyAssignDoctor",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedDoctor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "debugBagAsJson",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "04e20c65d82b994b907b9b06ffc42221",
    "metadata": {},
    "name": "sbotSimulatorDialogSimulateAutomaticallyAssignDoctorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "447607dcc51fc4e1a178ecb1e29aabd4";

export default node;
